var map = {
	"./amazon.svg": 797,
	"./american eagle.svg": 798,
	"./apple.svg": 799,
	"./bannana republic.svg": 800,
	"./best buy.svg": 801,
	"./costoco.svg": 802,
	"./ebay.svg": 803,
	"./kohls.svg": 804,
	"./llbean.svg": 805,
	"./macy's.svg": 806,
	"./nike.svg": 807,
	"./nordstorm.svg": 808,
	"./ralph lourn.svg": 809,
	"./ross.svg": 810,
	"./target.svg": 811,
	"./vectorya secret.svg": 812,
	"./walmart.svg": 813,
	"./zappos.svg": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 796;